import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
@Component({
  selector: 'app-addexpensepolicydetails',
  templateUrl: './addexpensepolicydetails.component.html',
  styleUrls: ['./addexpensepolicydetails.component.css']
})
export class AddexpensepolicydetailsComponent implements OnInit {


  constructor(private toastr: ToastrService, private appService: AppdataService,
    private loginService: LoginserviceService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) { }


  //Save Validation
  submitted: boolean;
  successfully: boolean;
  
  isduplicate: boolean;

  expensepolicydetailsform = new FormGroup({
    expensepolicydetid: new FormControl(0),
    expensetypeid: new FormControl(null, Validators.required),
    accuralperiod: new FormControl('', Validators.required),
    amountlimit: new FormControl(null,Validators.required),
    isallowoverlimit: new FormControl(false),

  });

  expensetypeColl: any = [];

  accurualperiodColl: any = [];


  @Input() expensepolicydetid: any = 0;
  @Input() expensetypeid: any = null;
  @Input() accuralperiod: any = '';
  @Input() amountlimit: any = '';
  @Input() isallowoverlimit: any = false;
  @Input() expensepolicydetailsColl: any = [];

  @Output() emitData = new EventEmitter();

  ngOnInit() {

    this.expensepolicydetailsform.reset();
    this.fnInitializeFormGroup();
    this.fngetExpensetype();
    this.fnGetAccurualPeriod();
  }


  fnInitializeFormGroup() {
    this.expensepolicydetailsform.setValue({
      expensepolicydetid: this.expensepolicydetid,
      expensetypeid: this.expensetypeid,
      accuralperiod: this.accuralperiod,
      amountlimit: this.amountlimit,
      isallowoverlimit: this.isallowoverlimit,
    })
  }
  fngetExpensetype() {
    var data = {
      'expensetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': ""
    }
    this.appService.getExpenseType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.expensetypeColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fnGetAccurualPeriod() {
    this.accurualperiodColl.push({ value: 'MONTHLY', displayname: 'Monthly' });
    this.accurualperiodColl.push({ value: 'YEARLY', displayname: 'Yearly' });

  }

  fnSaveBtnClick() {
    try {
     

      this.submitted = true;
      this.successfully = false;


      //Validate
      if (this.expensepolicydetailsform.valid) {
        
        var _expensetype = "";
        for (let row of this.expensetypeColl) {
          if (row.expensetypeid === this.expensepolicydetailsform.get('expensetypeid').value) {
            _expensetype = row.expensetypename;

          }
        }
        for (let row of this.expensepolicydetailsColl) {
          if (row.expensetypeid === this.expensepolicydetailsform.get('expensetypeid').value && this.expensetypeid !== this.expensepolicydetailsform.get('expensetypeid').value) {
            this.isduplicate = true;

            return;
          }



        }
        //Check
        var data = {
          expensepolicydetid: this.expensepolicydetid,
          expensetypeid: this.expensepolicydetailsform.get('expensetypeid').value,
          expensetypename: _expensetype,
          accuralperiod: this.expensepolicydetailsform.get('accuralperiod').value,
          amountlimit: this.expensepolicydetailsform.get('amountlimit').value,
          isallowoverlimit: this.expensepolicydetailsform.get('isallowoverlimit').value,
        }


        this.emitData.emit(data);
        this.activeModal.close(true);


      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
